import styled from "styled-components"

export const ProfileContainer = styled.div``
interface BanerProfileProps {
  bgImagen?: string
}

export const BanerProfile = styled.div<BanerProfileProps>`
  width: 100%;
  height: fit-content;
  background-position: top center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  background-image: url(${p => p.bgImagen ? p.bgImagen : ""});
  display: flex;
  flex-direction: row;
  position: relative;

  .container-profile {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    justify-items: center;
    width: 30%;
    margin-top: 10px;
    margin-bottom: 10px;

    .controls {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .controls > .photo {
      border-radius: 50%;
      opacity: 1;
      width: 150px;
      height: 150px;
      object-fit: cover;
      border: 1px solid #cecece;
    }

    .controls > .control-file {
      margin-top: 5px;
      width: 65px;
      height: 25px;
      background: #fbfbfb66 0% 0% no-repeat padding-box;
      border-radius: 12px;
      opacity: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      img {
        width: 25px;
        height: 20px;
      }
    }
  }

  .container-name {
    display: flex;
    align-items: center;

    .title-user {
      text-align: left;
      font: normal normal normal 40px MontserratRegular;
      letter-spacing: -0.8px;
      color: #ffffff;
      opacity: 1;
      height: 97px;
      margin-left: 50px;
      margin-top: 15px;
    }

    @media (max-width: 768px) {
      .container-name {
        padding-bottom: 15px;
      }

      .title-user {
        font-size: 20px;
        height: 60px;
        text-align: center;
        margin-left: 0;
      }
    }
  }

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .container-profile {
      width: 100%;
      margin-top: 20px;
      .controls {
        .photo {
          width: 90px;
          height: 90px;
        }
      }
    }
  }
`

export const CardForm = styled.div`
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 23px;
  opacity: 1;
  width: 850px;
  height: 480px;
  z-index: 2;
  position: absolute;
  right: 60px;
  top: 22%;
  .line-card {
    background: #2c2c2c 0% 0% no-repeat padding-box;
    opacity: 1;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    padding-top: 5px;
    padding-bottom: 5px;
    span {
      font: normal normal normal 30px/37px MontserratRegular;
      letter-spacing: 0px;
      color: #fbfbfbf9;
      opacity: 1;
    }
  }

  .card-form-items {
    display: flex;
    flex-direction: column;
    .item-control {
      display: flex;
      flex-direction: row;
      margin-top: 15px;
      margin-bottom: 15px;
      padding-top: 10px;
      padding-bottom: 10px;
      background: #9c94940d 0% 0% no-repeat padding-box;
      opacity: 1;
      .control-label {
        display: flex;
        flex-direction: row;
        width: 25%;
        margin-left: 20px;
        img {
          margin-right: 10px;
        }
        label {
          font: normal normal normal 24px MontserratRegular;
          letter-spacing: 0px;
          color: var(--color-text);
        }
      }
      .control-value {
        span {
          font: normal normal normal 24px MontserratRegular;
          letter-spacing: 0px;
          color: var(--color-text);
          opacity: 1;
        }
        .tag {
          border-radius: 10px;
          margin: 10px;
          margin-top: 20px;
          color: #707070;
          padding: 10px;
        }
        .tag.color-verde {
          background: #1e677a4d 0% 0% no-repeat padding-box;
        }
        .tag.color-blue {
          background: #91d7d380 0% 0% no-repeat padding-box;
        }
      }
    }
  }

  @media(max-width: 768px) {
    .card-form-items {
      height: 95vh !important;
    }
  }

  @media only screen and (max-width: 768px) {
    width: 95%;
    height: 650px;
    z-index: 2;
    position: absolute;
    right: 0px;
    top: 35%;
    margin-left: 10px;
    margin-right: 10px;
    .line-card {
      span {
      }
    }

    .card-form-items {
      .item-control {
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        margin-bottom: 20px;
        opacity: 1;
        .control-label {
          width: 100%;
          margin-left: 20px;
          img {
            margin-right: 10px;
          }
          label {
            font-size: 18px;
          }
        }
        .control-value {
          width: 100%;
          margin-left: 20px;
          margin-top: 10px;
          span {
            font-size: 18px;
          }
        }
      }
    }
  }
`
export const BadgeNotification = styled.div`
  width: 215px;
  height: 150px;
  background: #9c94944d 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 23px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 50px;
  margin-left: 100px;

  .title {
    font: normal normal normal 22px/27px MontserratRegular;
    letter-spacing: 0px;
    color: #707070;
    opacity: 1;
    margin-top: 10px;
  }
  .count {
    text-align: left;
    font: normal normal 600 56px/74px Segoe UI;
    letter-spacing: 0px;
    color: #707070;
    opacity: 1;
  }
`
